import { render, staticRenderFns } from "./ViewLogin.vue?vue&type=template&id=48988878&scoped=true&"
import script from "./ViewLogin.vue?vue&type=script&lang=js&"
export * from "./ViewLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48988878",
  null
  
)

export default component.exports